/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready (registration) {
      console.log(
        'App is being served from cache by a service worker.\n'
      )
      document.dispatchEvent(
        new CustomEvent('swReady', { detail: registration })
      )
    },
    registered () { 
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound (registration) {
      console.log('New content is downloading.')
      document.dispatchEvent(
        new CustomEvent('swUpdateFound', { detail: registration })
      )
    },
    updated (registration) {
      console.log('New content is available; please refresh.')
      document.dispatchEvent(
        new CustomEvent('swUpdated', { detail: registration })
      )
    },
    offline (registration) {
      console.log('No internet connection found. App is running in offline mode.')
      document.dispatchEvent(
        new CustomEvent('swOffline', { detail: registration })
      )
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
